import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "warning",
  "use": "warning-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"warning\"><path fill=\"currentColor\" class=\"st0\" d=\"M21.7 24H2.3c-.8 0-1.5-.4-1.9-1.1-.4-.7-.5-1.5-.1-2.2L9.7 1.4C10.1.6 11 0 12 0s1.9.6 2.3 1.4l9.5 19.3c.3.7.3 1.5-.1 2.2-.5.7-1.2 1.1-2 1.1zM12 1.5c-.4 0-.8.2-.9.6L1.6 21.4c-.1.2-.1.5 0 .7.1.2.4.4.7.4h19.5c.3 0 .5-.1.7-.4.1-.2.2-.5 0-.7L12.9 2.1c-.1-.4-.5-.6-.9-.6zm0 15c-.4 0-.8-.3-.8-.8V8.3c0-.4.3-.7.8-.7s.8.3.8.7v7.5c0 .4-.4.7-.8.7z\" /><path class=\"st0\" fill=\"currentColor\" d=\"M12 20.2c-.6 0-1.1-.5-1.1-1.1S11.4 18 12 18s1.1.5 1.1 1.1-.5 1.1-1.1 1.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/warning.svg
// module id = 55g1
// module chunks = 39 44